// extracted by mini-css-extract-plugin
export default {"container":"jr-z","brandName":"kr-z","productName":"lr-z","productNamePdpEnhancements":"mr-z","breakLongProductName":"nr-z"};